import { SpeciesUnitCost, SpeciesVolume } from '@/Domain/Batch/Species'

export class SpeciesTarget {
  private _cost: SpeciesUnitCost
  private _volume: SpeciesVolume

  constructor (cost: SpeciesUnitCost, volume: SpeciesVolume) {
    this._cost = cost
    this._volume = volume
  }

  cost (): string {
    return this._cost.toString()
  }

  volume (): string {
    return this._volume.toString()
  }
}
